import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { FuseNavigationService } from '@fuse/components/navigation';
import { selectDeveloperPlanId } from 'app/store/pricing/pricing.selectors';
import { loadPricingInfo } from 'app/store/pricing/pricing.actions';

@Component({
    selector: 'app-pricing-switcher',
    templateUrl: 'pricing-switcher.component.html',
    styleUrls: ['pricing-switcher.component.scss']
})

export class PricingSwitcherComponent implements OnInit {
    projectId: string;
    selectedPlan$: Observable<string> = this.store.select(selectDeveloperPlanId);

    constructor(
        private router: Router,
        private fuseNavigationService: FuseNavigationService,
        private store: Store
    ) {
        const parsedUrl = this.router.url.split('/');
        const idIndex = parsedUrl.findIndex(val => val === 'project') + 1;

        this.fuseNavigationService.projectId = parsedUrl[idIndex];
        this.projectId = this.fuseNavigationService.projectId;
    }

    ngOnInit() {
        this.store.dispatch(loadPricingInfo());
    }

    changePlan() {
        this.router.navigate(['/project', this.projectId, 'pricing'], {
            queryParamsHandling: 'preserve',
        });
    }
}